import React from 'react';
import { RHFTextField } from '@talentmesh/forms';
import Constants from '../Constants';
import ApplicantInformationType from '../../../../../../Models/ApplicantInformationType';
import useTMTranslation from '../../../../../../Hooks/useTMTranslation';

function WhyWorkInStartup(): React.JSX.Element {
    const { tCommon: t } = useTMTranslation();

    return (
        <RHFTextField
            multiline
            fullWidth
            label={`${t('WhyDoYouWantToWorkForStartup')}*`}
            name={ApplicantInformationType.WhyWorkInStartup}
            rows={Constants.numberOfRows}
            maxChar={Constants.textFieldLargeCapacity}
        />
    );
}

export default WhyWorkInStartup;
